export default __webpack_public_path__ + "static/media/whyBrokerIcon4.c288832f.webp";